// --- External Libraries
import moment from 'moment';
// --- Components
import { ClickableCellRenderer } from 'datastage/components/AGGrid/cell-renderers/clickable';
import { FunctionsCellRenderer } from 'datastage/components/AGGrid/cell-renderers/functions';
import NameCellEditor from 'datastage/components/AGGrid/cell-renderers/editor';
import NameCellRenderer from 'datastage/components/AGGrid/cell-renderers/name';

export const id = {
    field: 'id',
};

export const name = {
    field: 'name',
    headerName: 'Custom Field List Name',
    editable: true,
    cellEditor: NameCellEditor,
    cellRenderer: NameCellRenderer,
    minWidth: 300,
};

export const action = {
    field: 'actionShortName',
    headerName: 'Action',
};

export const module = {
    field: 'moduleName',
    headerName: 'Module',
};

export const template = {
    field: 'templateName',
    headerName: 'Template',
};

export const dateFormat = {
    field: 'dateFormatName',
    headerName: 'Date Format',
};

export const fields = {
    field: 'fieldKeys',
    headerName: 'Fields',
    valueFormatter: ({ value }) => (Array.isArray(value) ? value.length : ''),
};

export const createdAt = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).format('MMM D, YYYY') : ''),
};

export const updatedAt = {
    field: 'updatedAt',
    headerName: 'Updated',
    valueFormatter: ({ value }) => (value ? moment(value).format('MMM D, YYYY') : ''),
};

export const functions = (
    onLoadTemplate,
    onDeleteTemplate,
) => ({
    headerName: '',
    cellRenderer: FunctionsCellRenderer(onLoadTemplate, onDeleteTemplate),
});
